import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ConfirmationContent } from "./ConfirmationContent";
import UserNote from "../../offer/UserNote";
import Recipient from "../../offer/Recipient";
import Sender from "../../offer/Sender";
import LoadingSpinner from "../../../../common/LoadingSpinner";
import SonicApplication from "../../../../common/classes/SonicApplication";
import { ImageSourceSetData } from "../../../../common/classes/ImageSourceSet";
import { SonicMessage } from "../../../../common/classes/SonicMessage";
import Status from "../../../../common/management/detail/Status";
import styles from "../../../../common/management/AdminDashboardOffer.module.scss";
import AdminChatBox, { AdminChatBoxType } from "../../../chat/AdminChatBox";

type Props = {
  isSelect: boolean;
  isLoading: boolean;
  application: SonicApplication;
  projects: {
    name: string;
    owner_name: string;
    owner_email: string;
    owner_roles: Array<string>;
    owner_id: string;
    confirmations?: string;
    imgs: Array<ImageSourceSetData>;
  };
  showStatusMenu: boolean;
  handleUpdateStatus: () => void;
  handleStatusMenu: () => void;
  selectStatus?: string;
  setSelectStatus: (value: string) => void;
  isMemoEdit: boolean;
  handleMemoEdit: () => void;
  handleMemoUpdate: () => void;
  setMemo: (value: string) => void;
  messages: Array<SonicMessage>;
  hasNext: boolean;
  handleLoad: (page: number) => Promise<void>;
  handleReCreateRoom: () => void;
  chatboxType: AdminChatBoxType;
};

export const ProjectApplicationDetail: React.FC<Props> = ({
  isSelect,
  isLoading,
  application,
  projects,
  showStatusMenu,
  handleUpdateStatus,
  handleStatusMenu,
  selectStatus,
  setSelectStatus,
  isMemoEdit,
  handleMemoEdit,
  handleMemoUpdate,
  setMemo,
  messages,
  hasNext,
  handleLoad,
  handleReCreateRoom,
  chatboxType,
}) => {
  const [showChatMessages, setShowChatMessages] = useState<boolean>(false);

  const createRecipientLink = () => {
    if (isSelect === true) {
      return `/admin/member/${projects?.owner_id}`;
    } else if (projects?.owner_roles.includes("jikei_student")) {
      return `/jikei/student/${projects?.owner_id}`;
    } else {
      return `/jikei/manager/${projects?.owner_id}`;
    }
  };

  const createSenderLink = () => {
    if (isSelect === true) {
      return `/admin/member/${application?.applicant_id}`;
    } else if (application?.applicant_roles.includes("jikei_student")) {
      return `/jikei/student/${application?.applicant_id}`;
    } else {
      return `/jikei/manager/${application?.applicant_id}`;
    }
  };

  return (
    <div className={styles["f-adminOffer"]}>
      {isLoading === true ? (
        <LoadingSpinner space={1} admin_page={true} />
      ) : (
        <>
          <h1 className={styles["f-adminOffer__title"]}>応募詳細</h1>
          <div className={styles["f-adminOffer__inner"]}>
            <ConfirmationContent
              question={projects?.confirmations}
              answer={application?.message}
            />
            <Status
              isVisibilityStatus={false}
              status={application?.status}
              timestamp={application?.timestamp}
              showStatusMenu={showStatusMenu}
              handleUpdateStatus={handleUpdateStatus}
              handleStatusMenu={handleStatusMenu}
              selectStatus={selectStatus}
              setSelectStatus={setSelectStatus}
            />
            <UserNote
              memo={application?.memo}
              isMemoEdit={isMemoEdit}
              handleMemoEdit={handleMemoEdit}
              handleMemoUpdate={handleMemoUpdate}
              setMemo={setMemo}
            />
            <Recipient
              type="project"
              target_name={projects?.name}
              img={projects?.imgs?.[0].thumbnail.url}
              user_name={projects?.owner_name}
              mail_address={projects?.owner_email}
              link={createRecipientLink()}
              isStudent={isSelect ? false : true}
            >
              <div className={styles["f-adminOffer__arrow"]}>
                <FontAwesomeIcon icon={["fal", "arrow-left"]} />
                <span>APPLY</span>
              </div>
            </Recipient>
            <Sender
              type="project"
              user_name={application?.applicant_name}
              mail_address={application?.applicant_email}
              link={createSenderLink()}
              roles={application?.applicant_roles}
              school={application?.applicant_school}
              isSelect={isSelect ? true : false}
            />
          </div>
          <div className={styles["f-adminOffer__chat"]}>
            <button
              className={styles["f-adminOffer__chat-btn"]}
              onClick={() => setShowChatMessages(!showChatMessages)}
            >
              <FontAwesomeIcon icon={["far", "comment-alt"]} />
              ルームを{showChatMessages !== true ? "見る" : "閉じる"}
            </button>
          </div>
        </>
      )}
      <AdminChatBox
        isDisplay={showChatMessages}
        displayType={chatboxType}
        messages={messages}
        hasNext={hasNext}
        handleLoad={handleLoad}
        handleReCreateRoom={handleReCreateRoom}
      />
    </div>
  );
};
